import React, { useState } from 'react';
import QuestionEditor from 'app/common/richTextEditor/QuestionEditor';
import CodingGameEditor from './CodingGameEditor';
import PropTypes from 'prop-types';
import { handleChangeEditor, handleChangeExplanation, handleChangeBaseCode, handleChangeTestsCode } from './CodingGameForm.functions';
import { Button, LinearProgress } from '@material-ui/core';
import { CodingGameApi } from 'app/api/codingGameApi';
import './CodingGameForm.scss';

export function CodingGameForm({ codingGame, setCodingGame }) {

    const placeholderConfigExplanation = 'Insérez une proposition de solution';
    const [compileTestCodeResult, setcompileTestCodeResult] = useState([]);
    const [compileBaseCodeResult, setcompileBaseCodeResult] = useState([]);
    const [testsRunResult, setTestsRunResult] = useState([]);

    const [isFetchingTestResult, setIsFetchingTestResult] = useState(false);
    const [isFetchingBaseCodeCompileResult, setIsFetchingBaseCodeCompileResult] = useState(false);
    const [isFetchingTestCodeCompileResult, setIsFetchingTestCodeCompileResult] = useState(false);

    function compileTestCode() {
        setIsFetchingTestCodeCompileResult(true);
        CodingGameApi.testCompile(codingGame)
            .then((response) => {
                setcompileTestCodeResult([response?.data.message]);
            }, (error) => {
                const errorMessage = error?.response?.data.message || error?.message || 'An error occurred';
                setcompileTestCodeResult(errorMessage);
            })
            .finally(() => {
                setIsFetchingTestCodeCompileResult(false);
            });
    }

    function compileBaseCode() {
        setIsFetchingBaseCodeCompileResult(true);
        CodingGameApi.testCompile(codingGame)
            .then((response) => {
                setcompileBaseCodeResult([response?.data.message]);
            })
            .catch((error) => {
                const errorMessage = error?.response?.data.message || error?.message || 'An error occurred';
                setcompileBaseCodeResult(errorMessage);
            })
            .finally(() => {
                setIsFetchingBaseCodeCompileResult(false);
            });
    }

    function testSolutionCode() {
        setIsFetchingTestResult(true);
        CodingGameApi.trySolution(codingGame)
            .then((response) => {
                setTestsRunResult([response?.data.message]);
            }, (error) => {
                const errorMessage = error?.response?.data.message || error?.message || 'An error occurred';
                setTestsRunResult(errorMessage);
            })
            .finally(() => {
                setIsFetchingTestResult(false);
            });
    }

    /*
     * Attention, si jamais setCodingGame change lors de la vie du composant, ce sera pas prit en compte ici.
     * Si il y en a besoin, il faudra modifier questionouverte.js dans le ckeditor pour qu'il prenne setCodingGame en param
     */
    return (
        <div data-testid="question-ouverte-form">
            <QuestionEditor
                aria-label="question-ouverte-statement-editor"
                className="statementQuestionEditor"
                data={codingGame.statement}
                onChange={(_event, editor) => handleChangeEditor(editor, setCodingGame)}
                placeholder={'Insérez l\'énoncé'}
            />
            <div  className="codingGameForm">
                <div style={{ display: 'flex', paddingTop: '10px' }}>
                    <div style={{ width: '50%', paddingRight: '10px' }}>
                        <label>Code de base (fourni au répondant)</label>
                        <CodingGameEditor
                            className="explanationEditor"
                            data={codingGame.baseCode}
                            onChange={(_event, editor) => handleChangeBaseCode(editor, setCodingGame)}
                            placeholder={'Code de base'}
                        />
                        {isFetchingBaseCodeCompileResult &&
                                                    <LinearProgress
                                                        style={{ marginTop: '8px' }}
                                                    />
                        }
                        <div>
                            {compileBaseCodeResult}
                        </div>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => compileBaseCode()}
                            style={{ margin: '5px' }}
                            disabled={isFetchingBaseCodeCompileResult}
                        >Compiler</Button>
                    </div>

                    <div style={{ width: '50%', paddingLeft: '10px' }}>
                        <label>Tests unitaires (masqués au répondant, Junit5, AssertJ)</label>
                        <CodingGameEditor
                            className="explanationEditor"
                            data={codingGame.testsCode}
                            onChange={(_event, editor) => handleChangeTestsCode(editor, setCodingGame)}
                            placeholder={'Insérez les tests unitaires'}
                        />
                        {isFetchingTestCodeCompileResult &&
                                                    <LinearProgress
                                                        style={{ marginTop: '8px' }}
                                                    />
                        }
                        <div>{compileTestCodeResult}</div>

                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => compileTestCode()}
                            style={{ margin: '5px' }}
                            disabled={isFetchingTestCodeCompileResult}
                        >Compiler</Button>
                    </div>
                </div>
                <label>Code de la solution</label>
                <CodingGameEditor
                    className="explanationEditor"
                    data={codingGame.solutionCode}
                    onChange={(_event, editor) => handleChangeExplanation(editor, setCodingGame)}
                    placeholder={placeholderConfigExplanation}
                />
                {isFetchingTestResult &&
                                            <LinearProgress
                                                style={{ marginTop: '8px' }}
                                            />
                }
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => testSolutionCode()}
                    style={{ height: '100%', marginTop: '5px' }}
                    disabled={isFetchingTestResult}
                >Tester</Button>

                <div>{testsRunResult}</div>
            </div>
        </div>
    );
}

CodingGameForm.propTypes = {
    codingGame: PropTypes.object.isRequired,
    setCodingGame: PropTypes.func.isRequired
};
